<template>
    <div class="flex flex-col items-center justify-center h-full text-center">
        <img src="@/assets/images/gspe.png" alt="Logo Graha Sumber Prima Elektronik" class="w-64 h-auto mb-6">
        <h1 class="text-4xl font-bold text-gray-700"></h1>
        <p class="text-gray-500 mt-2"></p>
    </div>
</template>

<script>
export default {
    name: 'DashboardHome',
};
</script>